import { isAxiosError } from 'axios'

import { useQuery } from '@percent/utility'

import { useOrganisationProfileContext } from '../context/OrganisationProfileContext'

const MAX_RETRIES = 3

export const useOrganisationProfile = (organisationId: string) => {
  const { service } = useOrganisationProfileContext()

  return useQuery(
    ['organisationProfile', organisationId],
    service.getOrganisationProfile,
    { organisationId },
    {
      // A 4xx (bad id, not found, forbidden) won't change on retry; show the error straight away.
      retry: (failureCount, error) => {
        const status = isAxiosError(error) ? error.response?.status : undefined

        return (
          !(status && status >= 400 && status < 500) &&
          failureCount < MAX_RETRIES
        )
      },
    }
  )
}
